import { defineComponent as _defineComponent } from 'vue'
import { ChatActionItem } from '@/modules/Chat/interfaces/ChatActionItem';
import ChatAction from '@/modules/Chat/components/ChatAction.vue';

interface Props {
    chatActionList: ChatActionItem[];
    shouldButtonHaveBorder: boolean;
    isDisabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatKebabOptions',
  props: {
    chatActionList: null,
    shouldButtonHaveBorder: { type: Boolean },
    isDisabled: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true,ChatAction }
}

})